import React, { useState, useEffect } from 'react';
import { getBrowserWarning, isBrowserSupported, getBrowserInfo } from '../../utils/browserUtils';

const BrowserCompatibilityWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [browserInfo, setBrowserInfo] = useState(null);

  useEffect(() => {
    const warning = getBrowserWarning();
    const supported = isBrowserSupported();
    const info = getBrowserInfo();
    
    setBrowserInfo(info);
    
    if (warning || !supported) {
      setShowWarning(true);
    }
  }, []);

  if (!showWarning) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-yellow-800">
                <strong>Browser Compatibility Notice:</strong> {getBrowserWarning()}
              </p>
              {browserInfo && (
                <p className="text-xs text-yellow-700 mt-1">
                  Detected: {
                    browserInfo.isChrome ? 'Chrome' : 
                    browserInfo.isFirefox ? 'Firefox' : 
                    browserInfo.isSafari ? 'Safari' : 
                    browserInfo.isEdge ? 'Edge' : 
                    browserInfo.isOpera ? 'Opera' :
                    browserInfo.isIE ? 'Internet Explorer' :
                    'Unknown Browser'
                  }
                </p>
              )}
            </div>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={() => setShowWarning(false)}
              className="bg-yellow-50 rounded-md inline-flex text-yellow-400 hover:text-yellow-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
            >
              <span className="sr-only">Dismiss</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserCompatibilityWarning;
